module.exports = __webpack_public_path__ + "./images/ddb6ec24e89ea2aeceeabbdb2d739305.webp";